import { Link } from "react-router-dom";
import { ArrowRight, BookOpen, FlaskConical, Calculator, Library } from "lucide-react";
import { PageHero } from "../components/site/PageHero";
import { SectionLabel } from "../components/site/SectionLabel";
import { TechnicalDisclaimer } from "../components/site/TechnicalDisclaimer";
import { CTASection } from "../components/site/CTASection";

const SECTIONS = [
  { icon: BookOpen, title: "Polyurethane Knowledge Centre", body: "Fundamentals of PU formulation, raw-material selection, equivalent weights, NCO/OH balance and applications.", to: "/technical-hub/polyurethane", cta: "Explore Polyurethane" },
  { icon: FlaskConical, title: "Silicone Knowledge Centre", body: "HCR, LSR and RTV systems, compounding principles, reinforcing fillers, cure systems and formulation architecture.", to: "/technical-hub/silicones", cta: "Explore Silicones" },
  { icon: Calculator, title: "Engineering Calculators", body: "Practical PU calculation tools for engineers, formulators and technical sales professionals.", to: "/technical-hub/calculators", cta: "Open Calculators" },
  { icon: Library, title: "Technical Resource Library", body: "Curated manufacturer resources and technical references, organised around practical usefulness.", to: "/technical-hub/resources", cta: "Browse Resources" },
];

export default function TechnicalHub() {
  return (
    <div>
      <PageHero
        variant="dark"
        label="Technical Intelligence"
        title="Technical Hub"
        intro="Practical knowledge for industrial professionals. The objective is not simply to publish information — it is to explain how the underlying logic works."
        crumbs={[{ label: "Technical Hub" }]}
      />

      <section className="border-b border-brand-line bg-white">
        <div className="mx-auto max-w-7xl px-5 py-16 lg:px-8">
          <div className="grid gap-px border border-brand-line bg-brand-line md:grid-cols-2">
            {SECTIONS.map((s) => (
              <Link
                key={s.to}
                to={s.to}
                data-testid={`hub-${s.to.split("/").pop()}`}
                className="group flex flex-col bg-white p-8 transition-colors hover:bg-brand-blue/[0.03]"
              >
                <s.icon className="h-8 w-8 text-brand-blue" strokeWidth={1.5} />
                <h2 className="mt-5 font-heading text-xl font-bold text-brand-ink group-hover:text-brand-blue">
                  {s.title}
                </h2>
                <p className="mt-3 flex-1 text-[15px] leading-relaxed text-brand-muted">{s.body}</p>
                <span className="mt-5 inline-flex items-center gap-1.5 text-sm font-semibold text-brand-blue">
                  {s.cta} <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-1" />
                </span>
              </Link>
            ))}
          </div>

          <div className="mt-10">
            <TechnicalDisclaimer />
          </div>
        </div>
      </section>

      <CTASection
        label="Industrial advisory"
        title="Need commercial insight behind the technical detail?"
        body="MATRIVON combines this technical understanding with commercial assessment across polyurethane, silicones and specialty chemicals."
        primary={{ to: "/advisory/industrial-advisory", label: "Explore Industrial Advisory" }}
        secondary={{ to: "/contact", label: "Contact MATRIVON" }}
      />
    </div>
  );
}
